import { RequestMessage } from '@map/core';
import { DeviceAuthenticatorModule } from './DeviceAuthenticatorModule';

export class DeviceAuthenticatorHasBindingMessage extends RequestMessage {
  readonly tag: string = DeviceAuthenticatorModule.deviceAuthenticatorHasBindingMessageTag;
}
